import { useQueryClient } from '@tanstack/react-query';

import { type CommunityDetail, type Image, createCommunityDetail } from 'models';

import { useMutation } from 'query';
import { updateCommunity } from '../../services';
import { getCommunityQueryKey } from '../keys';

export const useUpdateCommunity = () => {
  const queryClient = useQueryClient();

  return useMutation<
    CommunityDetail,
    { data: { description?: string; htmlDescription?: string; image?: Image }; id: string }
  >({
    async mutationFn({ data, id }) {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
      const communityResponse = await updateCommunity(id, {
        cover_photo: data.image,
        description: data.description,
        html_description: data.htmlDescription,
      });
      /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

      return createCommunityDetail(communityResponse.data);
    },
    async onError(_, parameters) {
      await queryClient.invalidateQueries({ queryKey: getCommunityQueryKey({ id: parameters.id }) });
      // TODO this will be removed with useCommunityDataObjectQuery
      await queryClient.invalidateQueries({
        queryKey: ['data-object', ...getCommunityQueryKey({ id: parameters.id })],
      });
    },
    async onSuccess(data, parameters) {
      queryClient.setQueryData(getCommunityQueryKey({ id: parameters.id }), data);
      // TODO this will be removed with useCommunityDataObjectQuery
      await queryClient.invalidateQueries({
        queryKey: ['data-object', ...getCommunityQueryKey({ id: parameters.id })],
      });
    },
  });
};
